import React, { useEffect, useState } from 'react';
import {
  CouponAction,
  HeaderTitle,
  OfferContainerNew,
  OfferDetailsContainer,
  OffersListHeader,
} from './styled';
import Image from 'next/image';
import Cookies from 'js-cookie';

const OfferSectionNew = (props) => {
  const { offerData, eventHandler } = props;
  const [gesture, setGesture] = useState('');
  const getTopText = () => {
    if (true) {
      return '1 Offer available on checkout';
    } else {
      return `${offerCount} Offers available on checkout`;
    }
  };
  const onCopyCoupon = (data) => {
    if (!Cookies.get('coupon_code')) {
      Cookies.set('coupon_code', data);
    }
    window?.navigator.clipboard.writeText(`${data}`);
    eventHandler('copyCode');
  };
  const clickFeedback = () => {
    setGesture('lowOpacity');
    setTimeout(() => {
      setGesture('');
    }, 200);
  };
  useEffect(() => {
    if (!Cookies.get('coupon_code')) {
      Cookies.set('coupon_code', 'BABYCARE');
    }
  }, []);
  return (
    <OfferContainerNew>
      <OffersListHeader>
        <HeaderTitle>{getTopText()}</HeaderTitle>
      </OffersListHeader>
      <div
        className={`couponSection ${gesture}`}
        onClick={() => {
          eventHandler('copyCode');
          clickFeedback();
          onCopyCoupon(offerData?.code);
        }}
      >
        <p className="offerTitle">{offerData?.name}</p>
        <span className="offerValid">{offerData?.expire_date}</span>

        <OfferDetailsContainer>
          <ul className="offerDetails">
            {offerData?.description?.map((data, index) => {
              return (
                <li className="description" key={index}>
                  {data?.map((item, index) => {
                    return <p key={'desc' + index}>{item}</p>;
                  })}
                </li>
              );
            })}
          </ul>
          <div className="imgContainer">
            <Image
              src={offerData?.banner_image}
              alt=""
              quality={90}
              fill
              sizes="33vw"
            />
          </div>
        </OfferDetailsContainer>

        <CouponAction>
          <span className="couponCode">{offerData?.code}</span>
          <button className="copyButton">Copy code</button>
        </CouponAction>
      </div>
    </OfferContainerNew>
  );
};

export default OfferSectionNew;
